import classNames from 'classnames';
import moment from 'moment';
import { useEffect, useMemo, useState, useRef, useContext, useLayoutEffect } from 'react';
import AlarmIcon from '../../assets/builder/countdown/alarm.svg?react';
import { CheckoutComponentCountdownAttibutesType } from '../../types/builder';
import { CheckoutContext } from '../../contexts/CheckoutContext';

const CheckoutComponentCountdown: React.FC<CheckoutComponentCountdownAttibutesType> = ({
  activeText,
  backgroundColor,
  date,
  finishedText,
  fixedOnTop,
  textColor,
  time,
  type
}) => {
  const [counter, setCounter] = useState<number>(0);
  const [isTouchingTop, setIsTouchingTop] = useState(false);

  const { setCountdownHeight } = useContext(CheckoutContext);

  const finished = counter <= 0;

  useEffect(() => {
    const interval = setInterval(() => {
      setCounter((prev: number) => (prev > 0 ? prev - 1 : 0));
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (type === 'date' && date) {
      setCounter(moment(date).diff(moment(), 'seconds'));
    }
    if (type === 'time' && time) {
      const [minutes, seconds] = time.split(':');

      setCounter(parseInt(minutes) * 60 + parseInt(seconds));
    }
  }, [type, time, date]);

  const text = finished ? finishedText : activeText;

  const formatted = useMemo(() => moment.utc(counter * 1000).format('mm:ss'), [counter]);

  const ref = useRef(null);

  useLayoutEffect(() => {
    const { current } = ref;
    if (current) {
      setTimeout(() => {
        const { offsetHeight } = current;

        if (fixedOnTop && isTouchingTop) {
          setCountdownHeight(+offsetHeight);
        }
      }, 10);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fixedOnTop, isTouchingTop]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsTouchingTop(entry.boundingClientRect.top <= 0);
      },
      { threshold: [0] }
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      if (ref.current) {
        observer.unobserve(ref.current);
      }
    };
  }, [ref]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsTouchingTop(entry.boundingClientRect.top <= 0);
      },
      { threshold: [0] }
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      if (ref.current) {
        observer.unobserve(ref.current);
      }
    };
  }, [ref]);

  return (
    <div
      className={classNames(
        'rounded-lg p-4 flex flex-nowrap justify-center items-center gap-5 max-sm:gap-4 max-sm:p-4',
        {
          'fixed top-0 rounded-none left-0 right-0 w-full z-50': fixedOnTop && isTouchingTop
        }
      )}
      style={{
        backgroundColor,
        color: textColor
      }}
      ref={ref}
    >
      <h3 className="text-2xl font-bold max-sm:text-xl">{formatted}</h3>
      <AlarmIcon className="w-10 h-10 max-sm:w-8 max-sm:h-8" />
      <span className="text-sm max-sm:text-base">{text}</span>
    </div>
  );
};

export default CheckoutComponentCountdown;
